/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import gql from 'graphql-tag';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from 'shared/components/SnackBar/SnackBarContentWrapper';
import withClient from 'shared/components/ApolloClient/withClient';
import { errorAlert, successAlert } from 'shared/utilities/alerts';
import { navigateHome } from 'shared/utilities/navigation';
import { isEmpty } from 'shared/utilities/utils';
import PrimaryButton from 'shared/components/Buttons/PrimaryButton/PrimaryButton';
import Link from 'shared/components/Link';
import withStyles from './ForgotPasswordStyles';

const FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPassword($email: String!) {
    requestNewPassword(email: $email)
  }
`;

class ForgotPassword extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired, // eslint-disable-line
    // eslint-disable-next-line react/forbid-prop-types
    client: PropTypes.object.isRequired,
  };

  constructor() {
    super();

    this.state = {
      email: '',
      emptyEmailSnackbarOpen: false,
    };
  }

  handleValueChange = field => e => {
    this.setState({ [field]: e.target.value });
  };

  handleOpenEmailEmptySnackbar = () => {
    this.setState({ emptyEmailSnackbarOpen: true });
  };

  closeEmailEmptySnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ emptyEmailSnackbarOpen: false });
  };

  sendResetLink = async () => {
    const { email } = this.state;

    const emailAddress = email.trim().toLowerCase();
    if (isEmpty(emailAddress)) {
      this.setState({ emptyEmailSnackbarOpen: true });
      return;
    }

    try {
      await this.props.client.mutate({
        mutation: FORGOT_PASSWORD_MUTATION,
        variables: {
          email: emailAddress,
        },
      });

      successAlert('Success', 'Reset password email sent.');
      navigateHome();
    } catch (err) {
      errorAlert('Error', err.message);
    }
  };

  render = () => {
    const { handleValueChange } = this;
    const { email, emptyEmailSnackbarOpen } = this.state;
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Typography className={classes.title} variant="h4">
          Reset Your Password
        </Typography>
        <Typography className={classes.subHeader} variant="body1">
          {
            'Enter the email address associated with your account, and we’ll email you a link to reset your password.'
          }
        </Typography>
        <div className={classes.formContainer}>
          <TextField
            id="email"
            fullWidth
            label="EMAIL ADDRESS"
            onChange={handleValueChange('email')}
            type="email"
            value={email}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <PrimaryButton onClick={this.sendResetLink}>
            <div className={classes.textContainer}>
              <Typography variant>Send Password Reset Link</Typography>
            </div>
          </PrimaryButton>
        </div>
        <hr />
        <Typography className={classes.footerText}>
          {"Don't have an account yet? "}
          <Link to="/signup">Sign Up</Link>
        </Typography>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={emptyEmailSnackbarOpen}
          autoHideDuration={3000}
          onClose={this.closeEmailEmptySnackbar}
        >
          <MySnackbarContentWrapper
            onClose={this.closeEmailEmptySnackbar}
            variant="error"
            message="Please enter in an email."
          />
        </Snackbar>
      </div>
    );
  };
}

export default compose(withStyles, withClient)(ForgotPassword);
